import React from 'react';

import api from '../../../api/api';
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable";
import Modal from "./Modal.js";


const columns = [
    {
        Header: "id",
        id: "id",
        accessor: "id",
        show: false,
        private: true,
    },
    {
        Header: "Nombre",
        id: "apellido_nombre",
        accessor: d => d.apellido_nombre,
        show: true,
        width: 300,
    },
    {
        Header: "Email",
        id: "email",
        accessor: "email",
        filterable: true,
        show: true,
    },
    {
        Header: "Activo",
        id: "is_active",
        className: "text-center",
        accessor: d => (d.is_active ? "SI" : "NO"),
        filterable: true,
        width: 100,
        show: true,
    },
]

const Inversionistas = (props) => {

    const { modernTheme } = props;

    return (
        <ParadigmaTable
            modernTheme={modernTheme}
            buttons={[
                {
                    edit: true,
                    permission: 'usuarios_edit',
                    component: (props) => <Modal {...props} action="EDIT" />,
                },
            ]}
            apiUrl={api.inversionista.inversionista}
            columns={columns}
            title={"Usuarios"}
        />
    );
}

export default Inversionistas;



// WEBPACK FOOTER //
// ./src/views/Inversionistas/Configuracion/Inversionistas.js